var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFoodie(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    rx: 7,
    fill: "#D92D20",
    fillOpacity: 0.15
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.72444 21.352L13.1083 17.2487L14.6562 19.223L11.6727 23.0171C10.5301 24.4689 8.41581 22.9389 9.72444 21.352ZM13.6764 12.0077C13.9986 10.9562 13.8505 10.0578 12.6395 8.72311L9.68049 5.16345C9.26056 4.67027 8.27095 5.39458 8.68437 5.99192L11.051 8.90703C11.4986 9.45066 10.6668 10.1701 10.2046 9.61017L7.75662 6.59578C7.30088 6.0733 6.35847 6.76342 6.83537 7.36077C7.52549 8.19087 8.59323 9.5467 9.28335 10.3768C9.76187 10.8635 9.03432 11.5845 8.5623 10.9774L6.13223 7.98253C5.77577 7.59515 5.19308 7.83604 5.03845 8.28853C4.87243 8.77194 5.28097 9.12514 5.5593 9.48322L8.27095 12.9859C9.11244 13.9609 10.0532 14.5387 11.147 14.2115C11.3146 14.1611 11.5197 14.0585 11.7395 13.9234L19.0248 23.328C19.4171 23.8342 20.1739 23.8879 20.6655 23.4793L20.7778 23.3866C21.3312 22.9259 21.4207 22.0844 20.947 21.5408L13.232 12.6767C13.4566 12.426 13.621 12.1884 13.6764 12.0077ZM15.7386 14.0585L16.9382 12.6034C15.3952 8.77845 21.1131 3.68067 23.8849 6.02447C27.2525 8.87448 22.2475 15.7431 18.7302 14.0455L17.3093 15.8506L15.7386 14.0585Z",
    fill: "#D92D20"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFoodie);
export default __webpack_public_path__ + "static/media/foodie.7f75b55f90b5a8b567e0e573c54f9f4d.svg";
export { ForwardRef as ReactComponent };